import { Injectable } from "@angular/core";
import { createStore } from "@ngneat/elf";
import { withEntities } from "@ngneat/elf-entities";
import { localStorageStrategy, persistState } from "@ngneat/elf-persist-state";
import { Action } from "./action.model";
import { debounceTime } from "rxjs";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const actionsStore = createStore({ name: "actions" }, withEntities<Action<any>>());

@Injectable({ providedIn: "root" })
export class ActionsStore {
	constructor() {
		persistState(actionsStore, {
			storage: localStorageStrategy,
			source: () => actionsStore.pipe(debounceTime(1000)),
		});
	}

	public store = actionsStore;

	reset = () => {
		actionsStore.reset();
	};
}
